import * as React from "react";
const VideoProps = (props) => (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2574 8.51614C13.94 8.51614 13.6768 8.25292 13.6768 7.9355C13.6768 7.61808 13.94 7.35485 14.2574 7.35485C14.7142 7.35485 14.8148 7.28518 14.8226 7.28518C14.838 7.23873 14.838 6.96776 14.838 6.77421V5.22582C14.838 5.03227 14.838 4.76905 14.8071 4.69937C14.7993 4.70711 14.6832 4.64518 14.2574 4.64518C13.94 4.64518 13.6768 4.38195 13.6768 4.06453C13.6768 3.74711 13.94 3.48389 14.2574 3.48389C15.8677 3.48389 15.9993 4.27356 15.9993 5.22582V6.77421C15.9993 7.72647 15.8677 8.51614 14.2574 8.51614Z"
      fill={props.fill}
    />
    <path
      d="M4.32585 8.12904C4.2794 8.12904 4.23294 8.12129 4.18649 8.11355C3.87681 8.03613 3.68327 7.71871 3.76069 7.40904C3.99294 6.48775 3.99294 5.51226 3.76069 4.59097C3.68327 4.28129 3.86907 3.96388 4.18649 3.88646C4.49617 3.80904 4.80585 4.00258 4.88327 4.31226C5.16198 5.41936 5.16198 6.58839 4.88327 7.68775C4.82133 7.95097 4.58133 8.12904 4.32585 8.12904Z"
      fill={props.fill}
    />
    <path
      d="M7.03581 8.129C6.98936 8.129 6.9429 8.12126 6.89645 8.11351C6.58678 8.03609 6.39323 7.71868 6.47065 7.409C6.7029 6.48771 6.7029 5.51222 6.47065 4.59093C6.39323 4.28126 6.57903 3.96384 6.89645 3.88642C7.20613 3.809 7.52355 3.9948 7.60097 4.31222C7.87968 5.41932 7.87968 6.58835 7.60097 7.68771C7.53129 7.95093 7.29129 8.129 7.03581 8.129Z"
      fill={props.fill}
    />
    <path
      d="M8.45127 12H4.80611C1.39191 12 0.354492 10.9626 0.354492 7.54839V4.45161C0.354492 1.03742 1.39191 0 4.80611 0H8.45127C11.8655 0 12.9029 1.03742 12.9029 4.45161V7.54839C12.9029 10.9626 11.8655 12 8.45127 12ZM4.80611 1.16129C2.04223 1.16129 1.51578 1.68774 1.51578 4.45161V7.54839C1.51578 10.3123 2.04223 10.8387 4.80611 10.8387H8.45127C11.2151 10.8387 11.7416 10.3123 11.7416 7.54839V4.45161C11.7416 1.68774 11.2151 1.16129 8.45127 1.16129H4.80611Z"
      fill={props.fill}
    />
  </svg>
);
export default VideoProps;
